import { locale } from "moment";
import {
  FETCH_LANGUAGES,
  FETCH_TRANSLATION,
  UPDATE_LANGUAGE,
} from "../actions/types";

const initialState = {
  languages: [],
  translation: {},
};

export default function languageReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_LANGUAGES: {
      return {
        ...state,
        languages: action.payload,
      };
    }
    case FETCH_TRANSLATION: {
      return {
        ...state,
        translationHash: action.payload.translationHash,
        translation: action.payload.translation,
      };
    }

    case UPDATE_LANGUAGE: {
      return {
        ...state,
        locale: action.payload,
      };
    }
    default:
      return state;
  }
}
